module.exports = require('./helpers/bundle-url').getBundleURL('tOZgl') + "logo-dark.eefe0b7f.svg";